import { msg } from "@lingui/core/macro";

export const startTimeIsNowRuleMessages = {
	name: msg({ message: "Start Time Now" }),
	description: msg({ message: "Permit Start Time is set to the current time at registration time." }),
} as const;
